import { getCurrentLeafIsAtRoot } from 'sierra-client/views/v3-author/queries'
import { Editor } from 'slate'

export const isEnabled = (editor: Editor): boolean => {
  const isRootLevel = getCurrentLeafIsAtRoot(editor)

  return isRootLevel
}
